import { render, staticRenderFns } from "./solvePoint.vue?vue&type=template&id=023d3485&scoped=true"
import script from "./solvePoint.vue?vue&type=script&lang=js"
export * from "./solvePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d3485",
  null
  
)

export default component.exports